<template>
    <div>
        <div class="splide shadow" id="campaign-pictures" v-if="arrCampaignImage && arrCampaignImage.length > 1">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"
                        v-for="(image, k) in arrCampaignImage"
                        :key="k">
                        <!-- <img class="w-full" :src="image.fullImageUrl"> -->
                        <div class="bg-image" :style="{'background-image': `url('${image.fullImageUrl}')`}"></div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="detail-img" v-if="arrCampaignImage && arrCampaignImage.length == 1">
            <img :src="arrCampaignImage[0].fullImageUrl" class="img-fluid" />
        </div>
    </div>
</template>

<script>

import Splide from '@splidejs/splide'; //https://splidejs.com/

export default {
    name: "Picture",
    components: {

    },
    props: {
        arrCampaignImage: Array
    },
    data: function() {
        return {
            objCarouselConfig: {
                responsive: {
                    0: { items: 1 }
                }
            }
        };
    },
    mounted: function() {
        if (this.arrCampaignImage.length > 1) {
            new Splide('#campaign-pictures', {
                type: 'loop',
                arrows: false,
            }).mount();
        }
    },
};
</script>
<style lang="scss">
#campaign-pictures {
    .splide__pagination {
        margin-top: 15px;
        position: relative;

        .splide__pagination__page {
            width: 10px;
            height: 10px;
            margin: 5px 7px;
        }
        .is-active {
            transform: none;
        }
    }
}

</style>
<style lang="scss" scoped>
@import '@/style/base/image.scss';

.bg-image {
    @extend %img-square;
    &:before {
        position: relative;
        content: "";
        display: block;
        padding-top: 66.66%;
    }
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    box-shadow: 0 3px 4px 0 #999;
}
.bg-bottom-yellow {
    width: 100%;
    position: absolute;
    height: 120px;
    bottom: -65px;
}
.detail-img {
    position: relative;
    width: 100%; /* desired width */


    img {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        -webkit-box-shadow: 0px 3px 4px 0px rgba(153,153,153,1);
        -moz-box-shadow: 0px 3px 4px 0px rgba(153,153,153,1);
        box-shadow: 0px 3px 4px 0px rgba(153,153,153,1);
    }
}

.detail-img:before {
    content: "";
    display: block;
    padding-top: 66.66%; /* initial ratio of 1:1*/
}
</style>
